var dfs = require("./dfs");

module.exports = postorder;

function postorder(g, vs) {
  return dfs(g, vs, "post");
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphlib/lib/alg/postorder.js
// module id = 445
// module chunks = 0